function unifyListItemHeights(selector = 'li') {
  return new Promise(resolve => {
    requestAnimationFrame(() => {
      const items = document.querySelectorAll(selector);
      if (items.length === 0) {
        resolve();
        return;
      }

      // 重置高度
      items.forEach(item => {
        item.style.height = 'auto';
      });

      // 下一帧计算最高高度
      requestAnimationFrame(() => {
        let maxHeight = 0;
        items.forEach(item => {
          const height = item.offsetHeight || item.getBoundingClientRect().height;
          maxHeight = Math.max(maxHeight, height);
        });

        // 再下一帧设置统一高度（实现平滑过渡）
        requestAnimationFrame(() => {
          if (maxHeight > 0) {
            items.forEach(item => {
              // 添加CSS transition实现平滑过渡
              item.style.transition = 'height 0.3s ease';
              item.style.height = `${maxHeight}px`;
            });
            
            // 过渡完成后移除transition，避免影响后续样式
            setTimeout(() => {
              items.forEach(item => {
                item.style.transition = '';
              });
              resolve();
            }, 300);
          } else {
            resolve();
          }
        });
      });
    });
  });
}

// 只在窗口宽度 < 750px 时触发
function initMobileHeight(selector = 'li', delay = 250, maxWidth = 750) {
  let timeoutId;
  let isMobileMode = false;
  let isUpdating = false;
  
  // 优化MutationObserver的配置
  let observer = null;
  let observedContainer = null;
  
  const update = async () => {
    if (isUpdating) return;
    
    const isMobile = window.innerWidth < maxWidth;
    
    if (isMobile) {
      // 移动端模式：统一高度
      isUpdating = true;
      await unifyListItemHeights(selector);
      isMobileMode = true;
      isUpdating = false;
    } else if (isMobileMode) {
      // 从移动端切换到桌面端：重置高度
      isUpdating = true;
      requestAnimationFrame(() => {
        const items = document.querySelectorAll(selector);
        items.forEach(item => {
          // 添加平滑过渡
          item.style.transition = 'height 0.3s ease';
          item.style.height = 'auto';
        });
        
        setTimeout(() => {
          items.forEach(item => {
            item.style.transition = '';
          });
          isMobileMode = false;
          isUpdating = false;
        }, 300);
      });
    }
  };
  
  // 找到最近的公共容器，避免监听整个body
  const findCommonContainer = (selector) => {
    const items = document.querySelectorAll(selector);
    if (items.length === 0) return null;
    
    let commonAncestor = items[0].parentElement;
    
    for (let i = 1; i < items.length; i++) {
      const current = items[i];
      while (!commonAncestor.contains(current) && commonAncestor !== document.body) {
        commonAncestor = commonAncestor.parentElement;
      }
    }
    
    return commonAncestor || document.body;
  };
  
  // 优化版DOM变化监听
  const setupMutationObserver = () => {
    if (!window.MutationObserver) return;
    
    // 找到相关元素最近的公共容器
    observedContainer = findCommonContainer(selector);
    if (!observedContainer) return;
    
    // 创建精简的observer配置
    observer = new MutationObserver((mutations) => {
      // 只在移动端且不是正在更新时处理
      if (window.innerWidth >= maxWidth || isUpdating) return;
      
      for (const mutation of mutations) {
        if (mutation.type === 'childList') {
          // 快速检查是否有相关元素变化
          const addedHasMatch = Array.from(mutation.addedNodes).some(node => 
            node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))
          );
          
          const removedHasMatch = Array.from(mutation.removedNodes).some(node => 
            node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector))
          );
          
          if (addedHasMatch || removedHasMatch) {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(update, 100); // 更短的延迟
            break;
          }
        }
      }
    });
    
    // 只监听子节点变化，不监听属性或字符变化
    observer.observe(observedContainer, {
      childList: true,
      subtree: true
    });
  };
  
  // 初始执行
  update();
  
  // 监听窗口变化（防抖）
  const handleResize = () => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(update, delay);
  };
  
  window.addEventListener('resize', handleResize);
  
  // 延迟设置MutationObserver，避免初始加载时的性能冲击
  setTimeout(setupMutationObserver, 1000);
  
  // 返回包含清理方法的对象
  return {
    update,
    destroy: () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', handleResize);
      
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      
      // 重置所有元素高度
      const items = document.querySelectorAll(selector);
      items.forEach(item => {
        item.style.height = 'auto';
        item.style.transition = '';
      });
    },
    // 手动重新设置MutationObserver（当DOM结构发生重大变化时调用）
    refreshObserver: () => {
      if (observer) {
        observer.disconnect();
        observer = null;
      }
      setupMutationObserver();
    }
  };
}

document.addEventListener("DOMContentLoaded", () => {
  const heightManager = initMobileHeight('.image-below-banner li');
  // 页面卸载时清理
  window.addEventListener('beforeunload', () => {
    heightManager.destroy();
  });

  var header_height = 0;
  if($(".site-header").length && $(".site-header").outerHeight(true)) {
    header_height = $(".site-header").outerHeight(true);
  }
  $(document).off('click', ".image-below-banner .image-tab-item").on('click', ".image-below-banner .image-tab-item", function () {
    var target = $(this).attr("data-target");
    $("html, body").animate(
      {
        scrollTop: $(`.${target}`).offset().top - header_height + "px",
      },
      500
    );
    return false;
  });
  $(document).off('keydown', ".image-below-banner .popup-link").on('keydown', ".image-below-banner .popup-link", function (e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      $(this).find(".popup-add__submit").click();
    }
  });
});